var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWithSpring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400.22,
    height: 369.672,
    viewBox: "0 0 400.22 369.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.502,
    y1: 0.782,
    x2: 1.212,
    y2: -0.579,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#574ea0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee4492"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67023",
    "data-name": "Group 67023",
    transform: "translate(-1660 -694.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_324",
    "data-name": "Ellipse 324",
    transform: "translate(1674.141 813.609) rotate(9)",
    fill: "none",
    stroke: "#ffbcdb",
    strokeWidth: 1,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.446,
    cy: 45.197,
    rx: 195.446,
    ry: 45.197,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.446,
    cy: 45.197,
    rx: 194.946,
    ry: 44.697,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_325",
    "data-name": "Ellipse 325",
    transform: "translate(1674.141 860.609) rotate(9)",
    fill: "none",
    stroke: "#ffbcdb",
    strokeWidth: 1,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.446,
    cy: 45.197,
    rx: 195.446,
    ry: 45.197,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.446,
    cy: 45.197,
    rx: 194.946,
    ry: 44.697,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_326",
    "data-name": "Ellipse 326",
    transform: "translate(1674.141 913.57) rotate(9)",
    fill: "none",
    stroke: "#ffbcdb",
    strokeWidth: 1,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.446,
    cy: 45.197,
    rx: 195.446,
    ry: 45.197,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.446,
    cy: 45.197,
    rx: 194.946,
    ry: 44.697,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_108751",
    "data-name": "Group 108751",
    transform: "matrix(-0.485, 0.875, -0.875, -0.485, 2088.557, 648.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157016",
    "data-name": "Path 157016",
    d: "M44.4,113.043a12.948,12.948,0,0,1-6.643-1.808,12.366,12.366,0,0,1-5.14-8.476,14.509,14.509,0,0,1-4.669.791,12.949,12.949,0,0,1-6.643-1.808,10.551,10.551,0,0,1-3.243-3.323,13.793,13.793,0,0,1-1.6-3.778,14.46,14.46,0,0,1-4.338.683,12.945,12.945,0,0,1-6.643-1.808C-.05,89.948.05,82.568.08,81.738L.012,31.925a13.99,13.99,0,0,1,1.3-6.321,12.7,12.7,0,0,1,2.273-3.4,12.122,12.122,0,0,1,3.767-2.7,13.812,13.812,0,0,1,5.421-1.154,13.514,13.514,0,0,1,3.432.455,13.923,13.923,0,0,1,2.163-4.829,12.048,12.048,0,0,1,4.8-3.963,13.825,13.825,0,0,1,5.421-1.154,13.523,13.523,0,0,1,4.171.669,13.551,13.551,0,0,1,2.208-4.618,12.037,12.037,0,0,1,4.652-3.757A13.816,13.816,0,0,1,45.042,0a15.428,15.428,0,0,1,7.634,2.2L172.95,71.59l0-30.8-18.707,10.67-8.23-4.75,26.936-15.379v-8.14l-34,19.442-8.234-4.752,42.179-24.134c-.1-1.063-.486-3.636-1.82-4.551a5.32,5.32,0,0,0-2.838-.8,7.8,7.8,0,0,0-3.68,1.058l-41.523,24L114.8,28.7,160.437,2.329a15.984,15.984,0,0,1,7.8-2.162A13.6,13.6,0,0,1,175.6,2.33a11.4,11.4,0,0,1,3.355,3.627,15.286,15.286,0,0,1,1.651,4.124,14.633,14.633,0,0,1,3.447-.421,13.577,13.577,0,0,1,7.367,2.162,12.349,12.349,0,0,1,4.722,6.736,14.927,14.927,0,0,1,4.364-.672,13.6,13.6,0,0,1,7.367,2.162c5.9,4.049,5.618,12.314,5.566,13.242l.013,46.106a15.486,15.486,0,0,1-1.271,5.95,13.787,13.787,0,0,1-5.187,6.282,14.025,14.025,0,0,1-7.778,2.185A18.751,18.751,0,0,1,196,93.526a13.62,13.62,0,0,1-13.238,9.146,18.6,18.6,0,0,1-2.4-.162,14.229,14.229,0,0,1-5.64,7.469,14.022,14.022,0,0,1-7.778,2.185,19.284,19.284,0,0,1-6.673-1.231L40.53,41.7l.024,29.911,18.49-10.686,8.069,4.838L40.562,81.109l.006,7.974L74.206,70.018l8.08,4.845L40.575,98.53V99.6c-.031,1.46.423,3.943,1.494,4.635a4.712,4.712,0,0,0,2.328.583,6.641,6.641,0,0,0,2.779-.662L89.763,79.346l8.062,4.834L51.339,111.25A14.486,14.486,0,0,1,44.4,113.043Zm119.391-9.54a2.124,2.124,0,0,1,.255.053h.006a12.788,12.788,0,0,0,2.891.38,5.946,5.946,0,0,0,3.3-.855,6.134,6.134,0,0,0,2.458-3.647l-132.18-76.5.007,9.261L163.78,103.507S163.782,103.5,163.789,103.5ZM32.342,85.86,24.131,90.6c.058,1.217.435,3.458,1.486,4.137a4.705,4.705,0,0,0,2.328.583,6.448,6.448,0,0,0,2.779-.662l1.624-.92Zm148.835.068v8.395a10.894,10.894,0,0,0,1.584.124,5.951,5.951,0,0,0,3.3-.855,6.05,6.05,0,0,0,2.39-3.406l-7.27-4.258Zm-8.225,4.167V81.11L48.6,9.35a7.4,7.4,0,0,0-3.562-1.124,5.549,5.549,0,0,0-2.128.465C40.439,9.84,40.5,13.258,40.508,13.4V13.5ZM12.77,26.578a5.559,5.559,0,0,0-2.128.464c-2.476,1.149-2.411,4.567-2.407,4.712L8.3,81.879c-.031,1.461.423,3.944,1.494,4.636a4.7,4.7,0,0,0,2.328.583,6.78,6.78,0,0,0,2.779-.662l.99-.572-.059-58.427A6.877,6.877,0,0,0,12.77,26.578Zm187.736-.465a7.67,7.67,0,0,0-3.52.968L197,85.353a11.528,11.528,0,0,0,2.217.234,5.956,5.956,0,0,0,3.3-.855c2.654-1.726,2.716-5.245,2.715-5.279l-.006-46.389a13.024,13.024,0,0,0-.327-3.281,4.922,4.922,0,0,0-1.547-2.868A5.316,5.316,0,0,0,200.506,26.112ZM24.064,32.175l.05,48.938,8.219-4.75L32.3,36.941l-8.238-4.766Zm164.7-.408h0l-7.6,4.333.006,40.32,7.6,4.46,0-49.114ZM28.589,17.086a5.571,5.571,0,0,0-2.128.464c-2.476,1.15-2.41,4.567-2.406,4.712v.4l8.24,4.767-.007-9.148-.136-.077A7.414,7.414,0,0,0,28.589,17.086Zm155.463.8a7.379,7.379,0,0,0-2.886.657l0,8.095,7.435-4.245c-.17-1.061-.618-2.953-1.711-3.7A5.32,5.32,0,0,0,184.053,17.886Z",
    transform: "translate(137.391 40)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithSpring);
export default __webpack_public_path__ + "static/media/logo-with-spring.2a8c97d8826d84fa21ddb827e67e1c76.svg";
export { ForwardRef as ReactComponent };